import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js'

export default class extends Controller {
  setLoading(event) {
    event.target.style['pointer-events'] = 'none';
    const loader =  event.target.nextSibling.nextSibling;
    loader.style['display'] = 'inline-block';
  }

  getTurboStream(event) {
    event.preventDefault()
    get(event.currentTarget.href, {
      contentType: "text/vnd.turbo-stream.html",
      responseKind: "turbo-stream"
    })
  }
}
